import styled from 'styled-components';

export const Container = styled.div`
  overflow: hidden;
  padding: 60px 30px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 4;
`;
